import type { AccountListModel } from './account.type.ts';
import type { AccountRepresentativeListModel } from './account-representative.type.ts';
import type { AvailabilitySlotListModel } from './availability-slot.type.ts';
import type { LookupModel } from './lookup.type.ts';
import type { MeetingListModel } from './meeting.type.ts';
import type {
  AvailabilityLineItemModel,
  MeetingLineItemModel,
  RepLineItemModel,
  RxVantageLineItemModel,
  StaffLineItemModel,
} from './onboard-line-item.type.ts';
import type { StaffMemberListModel } from './staff-member.type.ts';
import type { UserListModel } from './user-type.ts';

export interface OnboardImportModel {
  key: string;
  id: number;
  startedAt: string;
  completedAt: string;
  percentComplete: number;
  createdAt: string;
  uploadedAt: string;
  importedByUser: UserListModel;
  totalLine: number;
  statusNotes: string;
  account: AccountListModel;
  onboardImportStatusType: LookupModel;
  onboardAvailabilitySlotImportLineItems: OnboardImportAvailabilitySlotLineItemModel[];
  onboardMeetingImportLineItems: OnboardImportMeetingLineItemModel[];
  onboardStaffImportLineItems: OnboardImportStaffLineItemModel[];
  onboardRepresentativeImportLineItems: OnboardImportRepLineItemModel[];
}

export interface OnboardImportListModel {
  key: string;
  id: number;
  startedAt: string;
  completedAt: string;
  percentComplete: number;
  createdAt: string;
  uploadedAt: string;
  importedByUser: UserListModel;
  statusNotes: string;
  account: AccountListModel;
  onboardImportStatusType: OnboardImportStatusType;
  availabilitySlotCount: number;
  representativeCount: number;
  meetingCount: number;
  staffMemberCount: number;
}

export enum OnboardImportStatusTypeEnum {
  InProgress = 1,
  Success = 2,
  Information = 3,
  Warning = 4,
  Error = 5,
}

export interface OnboardImportStatusType {
  id: OnboardImportStatusTypeEnum;
  description: string;
}

export interface OnboardImportRepLineItemModel extends OnboardImportLineItemBaseModel {
  jsonLineItem: RepLineItemModel;
  accountRepresentative: AccountRepresentativeListModel;
  emailSentAt: string;
}

export interface OnboardImportStaffLineItemModel extends OnboardImportLineItemBaseModel {
  jsonLineItem: StaffLineItemModel;
  staffMember: StaffMemberListModel;
  emailSentAt: string;
}

export interface OnboardImportMeetingLineItemModel extends OnboardImportLineItemBaseModel {
  jsonLineItem: MeetingLineItemModel;
  meeting: MeetingListModel;
}

export interface OnboardImportAvailabilitySlotLineItemModel extends OnboardImportLineItemBaseModel {
  availabilitySlot: AvailabilitySlotListModel;
  jsonLineItem: AvailabilityLineItemModel;
}

export interface OnboardImportLineItemBaseModel {
  rowNumber: number;
  id: number;
  onboardImportId: number;
  onboardImportStatuses: OnboardImportStatusModel[];
  rxVantageJsonLineItem: RxVantageLineItemModel;
}

export interface OnboardImportStatusModel {
  id: number;
  notes: string;
  onboardImportLineItemId: number;
  onboardImportStatusType: OnboardImportStatusType;
}

export enum OnboardImportTypeEnum {
  General = 1,
  RxVantage = 2,
}

export interface ImportModel {
  account: AccountListModel;
  fileUrl: string;
  onboardImportType: OnboardImportTypeEnum;
  timeZoneId: string;
}
